<script lang="ts" setup>
import { Button } from '~ds/components/ui/button';
import { Heading } from '~ds/components/ui/typography';

defineEmits<{
  click: [];
}>();
</script>

<template>
  <KUICoreCard
    rounding="3xl"
    padding="md"
    elevation="none"
    omit-background
    class="bg-linear-to-br from-brand-pink-subtle via-brand-purple-subtle to-background"
    data-testid="schools-feedback-cta"
  >
    <Heading
      size="lg"
      as="h2"
      class="mb-6 leading-none"
    >
      {{ $t('schools.feedback.cta.heading') }}
    </Heading>
    <Button
      size="sm"
      data-testid="schools-feedback-cta-button"
      type="button"
      @click="$emit('click')"
    >
      {{ $t('schools.feedback.cta.button') }}
    </Button>
  </KUICoreCard>
</template>
